import React, { useState } from "react";
import { Seo, Section, SectionHead, FadeUp } from "./Ui";
import axios from "axios";

export default function DrezoroContact() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [state, setState] = useState("idle"); // idle | sending | sent | error
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { setState("error"); return; }
    setState("sending");
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/drezoro/contact`, form);
      setState("sent");
    } catch { setState("error"); }
  };
  return (
    <div data-testid="drezoro-contact">
      <Seo title="Contact — DREZORO" description="Contact DREZORO for enterprise partnerships, press, investment, and general enquiries." />
      <Section>
        <div className="grid md:grid-cols-2 gap-16">
          <FadeUp>
            <SectionHead label="Contact" title="Talk to DREZORO."
              intro="Enterprise partnerships, press, investment, and general enquiries. We respond to every serious message." />
            <div className="space-y-5 text-sm">
              <div>
                <div className="dz-label mb-1.5">Business Email</div>
                <a href="mailto:info@drezoro.com" className="text-blue-400 hover:text-blue-300" data-testid="dz-contact-email">info@drezoro.com</a>
              </div>
              <div>
                <div className="dz-label mb-1.5">Headquarters</div>
                <p className="text-zinc-400">Headquartered in Western New York, USA.</p>
              </div>
              <div>
                <div className="dz-label mb-1.5">Social</div>
                <div className="flex gap-5 text-zinc-400">
                  <a href="https://www.linkedin.com/company/drezoro" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="dz-social-linkedin">LinkedIn</a>
                  <a href="https://x.com/drezoro" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="dz-social-x">X</a>
                  <a href="https://www.facebook.com/drezoro" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="dz-social-facebook">Facebook</a>
                </div>
              </div>
            </div>
          </FadeUp>
          <FadeUp delay={0.12}>
            {state === "sent" ? (
              <div className="dz-card p-10 text-center" data-testid="dz-contact-success">
                <div className="text-blue-400 text-3xl mb-4" aria-hidden="true">✓</div>
                <h3 className="text-lg font-medium">Message received.</h3>
                <p className="mt-2 text-sm text-zinc-400">Thank you — the DREZORO team will be in touch.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="dz-card p-7 space-y-4" data-testid="dz-contact-form" noValidate>
                <div>
                  <label htmlFor="dz-name" className="dz-label block mb-1.5">Full name</label>
                  <input id="dz-name" data-testid="dz-input-name" value={form.name} onChange={set("name")} autoComplete="name" required />
                </div>
                <div>
                  <label htmlFor="dz-email" className="dz-label block mb-1.5">Email</label>
                  <input id="dz-email" type="email" data-testid="dz-input-email" value={form.email} onChange={set("email")} autoComplete="email" required />
                </div>
                <div>
                  <label htmlFor="dz-company" className="dz-label block mb-1.5">Company (optional)</label>
                  <input id="dz-company" data-testid="dz-input-company" value={form.company} onChange={set("company")} autoComplete="organization" />
                </div>
                <div>
                  <label htmlFor="dz-message" className="dz-label block mb-1.5">Message</label>
                  <textarea id="dz-message" rows={5} data-testid="dz-input-message" value={form.message} onChange={set("message")} required />
                </div>
                {state === "error" && <p className="text-sm text-red-400" role="alert" data-testid="dz-contact-error">Please complete name, email, and message — then try again.</p>}
                <button type="submit" disabled={state === "sending"} className="dz-btn-primary w-full text-center disabled:opacity-60" data-testid="dz-contact-submit">
                  {state === "sending" ? "Sending…" : "Send Message"}
                </button>
              </form>
            )}
          </FadeUp>
        </div>
      </Section>
    </div>
  );
}
